import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearch = () => (
  <svg
    className={css.iconSvg}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
  >
    <path
      className={css.iconPath}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.167 15.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333ZM17.5 17.5l-3.625-3.625"
    />
  </svg>
);

export default IconSearch;
